
const DESIGN_ID = '15a265db-0000-0000-0000-mock00000002';

const designDocument = {
  ModularDesignType: 'VehicleStorage',
  Id: DESIGN_ID,
  DesignName: 'Mock Single Rack With Frame',
  Version: 1,
  ProductTypeId: 5,
  Sku: null,
  AnchorSide: 'Left',
  Matrix: null,
  Cart: null,
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'frame-001',
      Sku: 335917524,
      Name: 'PACKOUT Rack Frame',
      Type: 'Frame',
      Origin: { Row: 0, Column: 0, Height: 3595, Width: 2730 },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      ChoiceId: 258974,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'rack-001',
      Sku: null,
      Name: 'PACKOUT Rack',
      Type: 'Rack',
      Origin: { Row: 1320, Column: 0, Height: 2275, Width: 2730 },
      ParentIds: ['frame-001'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      ChoiceId: 261852,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'drawer-001',
      Sku: null,
      Name: 'PACKOUT Rack Drawer',
      Type: 'Drawer',
      Origin: { Row: 1420, Column: 0, Height: 300, Width: 2700 },
      ParentIds: ['rack-001'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      ChoiceId: 259266,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'drawer-002',
      Sku: null,
      Name: 'PACKOUT Rack Drawer',
      Type: 'Drawer',
      Origin: { Row: 2420, Column: 0, Height: 300, Width: 2700 },
      ParentIds: ['rack-001'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      ChoiceId: 259266,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'accessory-001',
      Type: 'Accessory',
      Sku: 320324795,
      Name: 'PACKOUT 19.5 in. Cabinet in Red',
      ChoiceId: 265425,
      Origin: { Row: 1720, Column: 0, Height: 700, Width: 2700 },
      ParentIds: ['rack-001'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      ChoiceBundle: null,
    },
  ],
};

const vehicleStorageBundleMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default vehicleStorageBundleMock;
